import { Link } from 'react-router-dom';
import { Icon } from '@/features/common/Icon';
import { CatalogCards } from '@/features/publicsite/CatalogCards';
import type { CatalogCountsProps } from '@/features/publicsite/types/catalog/CatalogCountsProps';
import { publicCatalogCards } from '@/i18n/dictionaries/publicCatalogCards';
import { publicHome } from '@/i18n/dictionaries/publicHome';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * The nine catalogue categories, rendered by the same component /catalog renders — exactly as the
 * template shared `_catalog-cards.html` between the two pages, so the categories cannot drift
 * between them. Only the section head around it belongs to the home page.
 */
export function HomeCatalog({ counts }: CatalogCountsProps) {
  const { t } = useTranslation(publicHome);
  const { t: tc } = useTranslation(publicCatalogCards);

  return (
    <section className="section" id="catalog">
      <div className="container">
        <div className="section-head">
          <div>
            <span className="eyebrow">{tc('eyebrow')}</span>
            <h2>{tc('heading')}</h2>
            <p>{tc('lead')}</p>
          </div>
          <Link className="head-link" to="/catalog">
            {t('catalogueSeeAll')} <Icon name="arrow-right" className="link-arrow" />
          </Link>
        </div>
        <div className="card-grid">
          <CatalogCards counts={counts} />
        </div>
      </div>
    </section>
  );
}
